import Menu from "pages/landing-page/assets/library/menu";
import DemoMenu from "pages/landing-page/assets/library/demo_menu";
import DemoContent from "pages/landing-page/assets/library/demo_content";
import { LandingService } from "connection/landing-controller";
import MediaBlocks from "pages/landing-page/assets/library/media_blocks";
import AdvantagesMenu from "pages/landing-page/assets/library/advantages";
import SituableBlocks from "pages/landing-page/assets/library/situable-for";
import { setItemsCount } from "./paginator";

const SET_MENU_ACTIVE = "SET-MENU-ACTIVE";
const SET_IS_SHOW_DEMO = "SET-IS-SHOW-DEMO";
const SET_IS_MESSAGE_SENDED = "SET-IS_MESSAGE-SENDED";
const SET_IS_DEMO_SUCCESS = "SET-IS-DEMO-SUCCESS";
const SET_IS_SHOW_MOBILE_MENU = "SET-IS-SHOW-MOBILE-MENU";
const SET_MESSAGES = "SET_MESSAGES";

const MenuLanding = {
    menuItems: Menu.pages,
    demoMenu: DemoMenu.pages,
    demoContent: DemoContent.content,
    mediaBlocks: MediaBlocks.blocks,
    activeMenu: null,
    isShowDemo: false,
    isMessageSended: false,
    isDemoSuccess: false,
    advantagesMenu: AdvantagesMenu.menu,
    situableBlocks: SituableBlocks.blocks,
    isShowMobileMenu: false,
    messages: [],
    messagesHeader: ["#","SENDERS_NAME", "PHONE", "EMAIL", "CREATED_AT", "SCOPE_ACTIVITY", "MESSAGE_TEXT", "KEYWORDS", "REQUEST_TYPE"],
    LanguageItems: 
    [
        {name: "Русский", short_name: 'RUS', title: 'RUSSIAN'},
        {name: "Қазақ", short_name: 'KAZ', title: 'KAZAKH'},
        {name: "English", short_name: 'ENG', title: 'ENGLISH'}
    ],
    page: 0,
    count: 0,
}

const LandingMenu = (state = MenuLanding, action) => {
    switch(action.type){
        case SET_MENU_ACTIVE:
            return {...state, activeMenu: action.activeMenu}
        case SET_IS_SHOW_DEMO:
            return {...state, isShowDemo: action.isShowDemo}
        case SET_IS_MESSAGE_SENDED:
            return {...state, isMessageSended: action.isMessageSended}
        case SET_IS_DEMO_SUCCESS:
            return {...state, isDemoSuccess: action.isDemoSuccess}
        case SET_IS_SHOW_MOBILE_MENU:
            return {...state, isShowMobileMenu: action.isShowMobileMenu}
        case SET_MESSAGES:
            let count = action.messages && action.messages.totalElements ? action.messages.totalElements : 0;
            let page = action.messages && action.messages.number ? action.messages.number : 0
            return {...state, messages: action.messages, count: count, page: page}
        default:
            return {...state}
    }
}

export default LandingMenu;

export const setIsShowMobileMenu = (isShowMobileMenu) => {
    return {
        type: SET_IS_SHOW_MOBILE_MENU,
        isShowMobileMenu: isShowMobileMenu
    }
}

export const setIsDemoSuccess = (isDemoSuccess) => {
    return {
        type: SET_IS_DEMO_SUCCESS,
        isDemoSuccess: isDemoSuccess
    }
}

export const setIsMessageSended = (isMessageSended) => {
    return {
        type: SET_IS_MESSAGE_SENDED,
        isMessageSended: isMessageSended
    }
}

export const setMessages = (messages) => {
    return {
        type: SET_MESSAGES,
        messages: messages
    }
}

export const getMessages = (page, count) => {
    return (dispatch) => {
        LandingService.getAllMessages(page, count).then(data => {
            dispatch(setItemsCount(data.totalElements))
            dispatch(setMessages(data));
        });
    }
}


export const sendMessage = (clientName, phoneNumber, requestType, message, industry, email) => {
    return (dispatch) => {
        LandingService.sendMessage(clientName, phoneNumber, requestType, message, industry, email).then(data => {
            dispatch(setIsDemoSuccess(true));
        });
    }
}

export const setIsShowDemo = (isShowDemo) => {
    return {
        type: SET_IS_SHOW_DEMO,
        isShowDemo: isShowDemo
    }
}

export const setMenuActive = (activeMenu) => {
    return {
        type: SET_MENU_ACTIVE,
        activeMenu: activeMenu
    }
}